export enum OrderStatus {
  New = 'NEW',
  Accepted = 'ACCEPTED',
  Dispatched = 'DISPATCHED',
  Rejected = 'REJECTED',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
  Submitted = 'SUBMITTED',
  Received = 'RECEIVED',
  Unknown = 'UNKNOWN',
}

type StatusMetadata = {
  title: string;
  visible: boolean;
};

export const SupplierOrderStatuses: Record<OrderStatus, StatusMetadata> = {
  [OrderStatus.Submitted]: { title: 'Order Received', visible: true },
  [OrderStatus.Rejected]: { title: 'Order Rejected', visible: true },
  [OrderStatus.Accepted]: { title: 'Order Accepted', visible: true },
  [OrderStatus.Dispatched]: { title: 'Order Dispatched', visible: true },
  [OrderStatus.Received]: { title: 'Order Received by Store', visible: true },
  [OrderStatus.Completed]: { title: 'Order Completed', visible: true },
  [OrderStatus.New]: { title: 'Supervisor to Review', visible: false },
  [OrderStatus.Canceled]: { title: 'Canceled', visible: true },
  [OrderStatus.Unknown]: { title: 'Unknown', visible: false },
};

export const CustomerOrderStatuses: Record<OrderStatus, StatusMetadata> = {
  [OrderStatus.New]: { title: 'Order Created', visible: true },
  [OrderStatus.Submitted]: { title: 'Submitted to Supplier', visible: true },
  [OrderStatus.Accepted]: { title: 'Accepted by Supplier', visible: true },
  [OrderStatus.Dispatched]: { title: 'Dispatched by Supplier', visible: true },
  [OrderStatus.Received]: { title: 'Received Order', visible: true },
  [OrderStatus.Completed]: { title: 'Completed by Supplier', visible: true },
  [OrderStatus.Rejected]: { title: 'Order Rejected', visible: true },
  [OrderStatus.Canceled]: { title: 'Order Canceled', visible: false },
  [OrderStatus.Unknown]: { title: 'Unknown', visible: false },
};

export const getSupplierOrderStatusTitle = (order: {
  status: OrderStatus;
  editedBySupplier?: boolean;
}): string => {
  if (order.status === OrderStatus.Accepted && order.editedBySupplier) {
    return 'Edited & Accepted by Supplier';
  }
  return SupplierOrderStatuses[order.status].title || 'Unknown Status';
};

export const getCustomerOrderStatusTitle = (order: {
  status: OrderStatus;
  editedBySupplier?: boolean;
}): string => {
  if (order.status === OrderStatus.Accepted && order.editedBySupplier) {
    return 'Edited & Accepted by Supplier';
  }
  return CustomerOrderStatuses[order.status].title || 'Unknown Status';
};

export const isOrderAccepted = (status: OrderStatus | { status: OrderStatus }): boolean => {
  const value = typeof status === 'object' ? status.status : status;
  return (
    value === OrderStatus.Accepted ||
    value === OrderStatus.Completed ||
    value === OrderStatus.Received ||
    value === OrderStatus.Dispatched
  );
};

export const isOrderRejected = (status: OrderStatus | { status: OrderStatus }): boolean => {
  const value = typeof status === 'object' ? status.status : status;
  return value === OrderStatus.Rejected;
};
